//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import VueMarkdown from "vue-markdown";
export default {
  data() {
    return {
      iconList: ["temperature", "timer"],
    };
  },
  components: {
    VueMarkdown,
  },
  computed: {
    ...mapGetters({
      ruleSet: "all-about-tea/brewRules",
    }),
  },
  props: {
    data: {
      type: Array,
    },
    itemIndex: {
      type: Number,
      default: null,
    },
  },
};
